import React from 'react';
import classNames from 'classnames';
import PlayButton from '../../../../components/play-button';
import './styles.scss';

const Preview = ({
  title,
  previewImageUrlSmall,
  previewImageUrlLarge,
  previewVideo,
  onPlayCoursePreview,
  className,
}) => (
  <div className={classNames('specific-course-screen__preview-block', className)}>
    <h1>
      {title}
    </h1>
    <div className="specific-course-screen__preview-block-thumbnail" onClick={() => onPlayCoursePreview(previewVideo)}>
      <picture>
        <source media="(min-width: 992px)" srcSet={previewImageUrlLarge} />
        <img src={previewImageUrlSmall} alt={title} className="specific-course-screen__preview-block-thumbnail-image" />
      </picture>
      <PlayButton />
    </div>
  </div>
);

export default Preview;
